import { API_BASE_URL } from '../utils/constants';
import axiosInstance from './axiosInstance';
import { mapFrontendToBackend, mapBackendToFrontend } from '../utils/citationFieldMapper';

export const CitationService = {
	/**
	 * Create a new citation
	 * @param {string} category - Citation category from config (e.g., 'Web Content')
	 * @param {string} source - Citation source from config (e.g., 'Blog Post')
	 * @param {object} formData - Form data from citation modal
	 * @param {string} documentId - ID of the document to attach citation to
	 */
	createCitation: async (category, source, formData, documentId) => {
		try {
			// Transform frontend data to backend schema
			const backendData = mapFrontendToBackend(category, source, formData, documentId);

			console.log('Creating citation:', { category, source, backendData });

			const response = await axiosInstance.post(`${API_BASE_URL}/citation`, backendData);

			// Transform response back to frontend format
			if (response.data.citation) {
				response.data.citation = mapBackendToFrontend(response.data.citation);
			}

			return response.data;
		} catch (error) {
			console.error('Citation creation error:', error.response?.data || error);
			throw error;
		}
	},

	/**
	 * Update an existing citation
	 * @param {string} citationId - ID of citation to update
	 * @param {string} category - Citation category from config
	 * @param {string} source - Citation source from config
	 * @param {object} formData - Updated form data
	 * @param {string} documentId - Document ID
	 */
	updateCitation: async (citationId, category, source, formData, documentId) => {
		try {
			// Transform frontend data to backend schema
			const backendData = mapFrontendToBackend(category, source, formData, documentId);

			console.log('Updating citation:', { citationId, category, source, backendData });

			const response = await axiosInstance.put(
				`${API_BASE_URL}/citation/${citationId}`,
				backendData
			);

			// Transform response back to frontend format
			if (response.data.citation) {
				response.data.citation = mapBackendToFrontend(response.data.citation);
			}

			return response.data;
		} catch (error) {
			console.error('Citation update error:', error.response?.data || error);
			throw error;
		}
	},

	/**
	 * Delete a citation
	 * @param {string} citationId - ID of citation to delete
	 */
	deleteCitation: async (citationId) => {
		try {
			const response = await axiosInstance.delete(`${API_BASE_URL}/citation/${citationId}`);
			return response.data;
		} catch (error) {
			console.error('Citation deletion error:', error.response?.data || error);
			throw error;
		}
	}
};
